/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S14_I2Inputs */

const tr_kullanim_s14_i2 = /** @type {(inputs: Kullanim_S14_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform altyapısına yönelik sömürü, olağandışı yük veya güvenlik ihlali girişimi`)
};

const en_kullanim_s14_i2 = /** @type {(inputs: Kullanim_S14_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exploitation of the Platform infrastructure, unusual load or an attempted security breach`)
};

const de_kullanim_s14_i2 = /** @type {(inputs: Kullanim_S14_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausnutzung der Plattforminfrastruktur, ungewöhnliche Last oder Versuch einer Sicherheitsverletzung`)
};

const ru_kullanim_s14_i2 = /** @type {(inputs: Kullanim_S14_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эксплуатация инфраструктуры Платформы, необычная нагрузка или попытка нарушения безопасности`)
};

/**
* | output |
* | --- |
* | "Exploitation of the Platform infrastructure, unusual load or an attempted security breach" |
*
* @param {Kullanim_S14_I2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s14_i2 = /** @type {((inputs?: Kullanim_S14_I2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S14_I2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s14_i2(inputs)
	if (locale === "de") return de_kullanim_s14_i2(inputs)
	if (locale === "ru") return ru_kullanim_s14_i2(inputs)
	return tr_kullanim_s14_i2(inputs)
});